module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-year-nav-set-wrapper"
  }, _vm._l((_vm.sortedIncrements), function(increment) {
    return _c('year-nav-button', {
      key: increment,
      attrs: {
        "state": _vm.state,
        "direction": _vm.direction,
        "increment": increment
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d13cfc16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map-controls/MapControlsYearNavigationSet.vue
// module id = 559
// module chunks = 1